Backbone.Radio.channel('views').reply('form-premiums',function(options){
	var premiumData = {
		 id:""
		,sfid:""
		,amount:""
		,category:""
		,limited:false
		,title:""
		,ticket_location:""
		,ticket_date:""
		,ticket_time:""
	}
	
	
	
	
	/*
	 *	Trigger	
	 *		Events
	 */
	var triggerUpdated = function(){
		radio.trigger("premiums:updated",premiumData)
	}	
	
	
	
	
	var radio = Backbone.Radio.channel('pledgeform')
	
	var singleView = Marionette.View.extend({
		 template:_.template($("#tmpl-form-premium").html())
		,className:function(){
			var classNames = 'col-sm-6 col-md-3 col-lg-2 gift mt4';
			if(this.model.attributes.Realtime_inventory__c){
				classNames += " limitedGift";
			}
			return classNames
		}
		,templateContext:function(){
			var  amount = this.model.attributes.Minimum_Sustainer_Amount__c
				,formattedAmount
				,amountSuffix = "monthly";
			
			if(this.options.collectionType==="onetime"){ 
				amount = this.model.attributes.Minimum_Pledge_Amount__c; 
				amountSuffix = "Level";
			}
			
			formattedAmount = amount;
			if(typeof formattedAmount==="string" && formattedAmount.indexOf(".") !== -1){ formattedAmount.toFixed(2); }

			return{
				 amount:amount
				,formattedAmount:formattedAmount
				,amountSuffix:amountSuffix
			}
		}
		,onRender:function(){
			var that = this;
			var image = new Image();

			image.onload = function() {
				//console.log('all is well')
			}
			image.onerror = function() {
				// image did not load, replace with placeholder image
				that.$el.find('img').attr('src','/assets/img/premiumPlaceholder.jpg')
			}
			image.src = this.$el.find('img').attr('src');
		}
	})
	var collectionView = Mn.CollectionView.extend({
         tagName: 'div'
        ,className:"row mx0"
        ,childView: singleView
        ,childViewOptions:function(a){
	        return {
		        collectionType:this.options.attributes.type
	        };
        }
        ,initialize:function(){
	        //console.log('yo',this)
        }
    });
	
	
	
	
	var view = Marionette.View.extend({
		 template:_.template($("#tmpl-form-premiums").html())
		,regions:{
			 sustainer_featured:{ el:"#featuredGifts .sustainer-gifts" }
			,sustainer:{ el:"#giftList .sustainer-gifts" }
			,onetime_featured:{ el:"#featuredGifts .onetime-gifts" }
			,onetime:{ el:"#giftList .onetime-gifts" }
		}
		,onRender:function(){
			var that = this;
			$.when( Backbone.Radio.channel('entities').request('premiums') ).done(function(data){ 
				that.showChildView('sustainer_featured', new collectionView({ collection:data.filterByFeatured({ type:"sustainer" }),attributes:{ type:"sustainer" }}))
				that.showChildView('sustainer', new collectionView({ collection:data.filterBySustainer(),attributes:{ type:"sustainer" }}))
				if(Backbone.settings.qs.cat && Backbone.settings.qs.cat==="tickets"){
					that.showChildView('onetime_featured', new collectionView({ collection:data.filterByCategory({ category:"tickets" }),attributes:{ type:"onetime" } }) )
				}else{
					that.showChildView('onetime_featured', new collectionView({ collection:data.filterByFeatured({ type:"onetime" }),attributes:{ type:"onetime" }}))
				}
				that.showChildView('onetime', new collectionView({ collection:data.filterByOneTime(),attributes:{ type:"onetime" }}))
				
				// Donation doesn't have to make any calls, so it always fires before we are ready, so ask it to fire the update again
				Backbone.Radio.channel('pledgeform').request('donation:request');
			
				//passed in from querystring
				if(Backbone.settings.qs.premium){
					$('#selectedGift').trigger('click')
					//if the premium is one of the featured ones, we don't need to open the second set
					if(!$('input[name="gifts"][value="'+Backbone.settings.qs.premium+'"]:visible').length){
						$('#showAllGiftsTrigger').trigger('click')
					}
					$('input[name="gifts"][value="'+Backbone.settings.qs.premium+'"]:visible').trigger('click')
				}
			})
		}
		,events:{
			/* The radio buttons that toggle whole section visibility */
			"click [name=gift]":function(e){
				if($(e.currentTarget).attr('id')=='selectedGift'){
					this.$el.find('#giftsContainer').show();
				}else{
					this.$el.find('#giftsContainer').hide();
					this.$el.find('#selectedGift').val('');
					this.$el.find('[name=gifts]:checked').prop('checked',false);
					this.$el.find(".gift.selected").removeClass('selected');
					this.clearPremiumData();
				}

			}
			,"click #showAllGiftsTrigger":function(e){
				if( $(e.currentTarget).text() == 'Hide gifts'){
					this.$el.find('#giftList').hide();
					$(e.currentTarget).text('Show all gifts')
				}else{
					this.$el.find('#giftList').show();
					$(e.currentTarget).text('Hide gifts')
				}
			}
			// selecting a specific premium
			,"click #gifts [name=gifts]":"selectedPremium"
			,"click #gifts .gift img":function(e){
				this.$el.find(e.currentTarget).parents('.gift').find('[name=gifts]').trigger('click')
			}
			,"keyup #form-premiums-filter":"filterPremiums"
		}
		
		,onAttach:function(){
			var that = this;
			
			radio.on("donation:updated",function(data){
				var container = '.sustainer-gifts';
				if(data.type!='sustainer'){ container = '.onetime-gifts'; }
				
				// Hide/show the correct set of premiums
				if(data.type==='sustainer'){
					that.$el.find('.onetime-gifts').hide();
				}else{
					that.$el.find('.sustainer-gifts').hide();
				}

				that.$el.find(container).show();
				
				//if gift selected and cost > amount, unselect gift
				var $selectedGift = $(container+':visible [name=gifts]:checked');
				if( $selectedGift.length ){
					if( +$selectedGift.data('amount') > data.amount ){
						$selectedGift.prop('checked',false);
						this.$el.find(".gift.selected").removeClass('selected');
						this.$el.find('#selectedGift').parent().prev().children('input').trigger('click');
						that.clearPremiumData();
					}
				}
				
				// Show All Premiums
				var allGifts = that.$el.find('#giftsContainer').find('.gift')
				allGifts.show();
				
				// Filter by text
				var filterTerm = that.$el.find('#form-premiums-filter').val().toLowerCase();
				if(filterTerm){
					allGifts.each(function(){
						var giftText = $(this).find(".giftTitle").text();
						giftText += " "+$(this).find(".giftDescription").text();
						if(!giftText.toLowerCase().includes(filterTerm)){
							$(this).hide();
						}
					});
				}
				
				//for volunteers, hide gifts that the pledge can't afford - PT#75988062
				// Note that this broke at some point and was reimplemented as part of PT#90895056
				if((Backbone.settings.flags.volunteer || Backbone.settings.flags.callcenter) && data.amount != 0){
					that.$el.find('#giftsContainer').find(container).find('.gift').each(function(){
						//sometimes this function is merely clearing the inputs, in which case we want all gifts to show
						if( +$(this).find('input').data('amount') > data.amount){
							$(this).hide();
						}
					});
				}

				// can't buy tickets on installments
				//console.log('data type', data.type)
				if(data.type=="installment"){
					//console.log('asdfasdfa', that.$el.find('.limitedGift').length)
					that.$el.find('.limitedGift').hide()
				}
	
				triggerUpdated()
			});
			
			if(Backbone.settings.flags.volunteer || Backbone.settings.flags.callcenter){
				/* Only show the 'cd name' gift input if a radio station is selected ~PT75988062 */
				radio.on("stations:updated",function(data){
					if(data.station.startsWith('FM')){
						that.$el.find('#cdNameContainer').removeClass('d-none')
					}else{
						that.$el.find('#cdNameContainer').addClass('d-none')
					}
				});
			}
			
			if(Backbone.settings.qs.cat && Backbone.settings.qs.cat==="tickets"){
				that.$el.find('.sustainer-gifts').hide();
				that.$el.find('.onetime-gifts').show();
				$('#selectedGift').trigger('click')
			}
		}
		,filterPremiums:function(){
			// Properly filtering premiums requires we know the type of pledge,
			//	which comes from another module. So call it and when it fires an update,
			//	the `on("donation:updated"` above will fire, updating the premiums
			Backbone.Radio.channel('pledgeform').request('donation:request');
		}
		,selectedPremium:function(e){
			var selected = $(e.currentTarget)
			this.$el.find('#selectedGift').val( selected.val() );
			
			//visual effect to show selected item
			this.$el.find(".gift.selected").removeClass('selected')
			selected.parents('.gift').addClass('selected');

			premiumData.id = selected.val();
			premiumData.sfid = selected.data("sfid");
			premiumData.amount = selected.data("amount");
			premiumData.category = selected.data("category");
			premiumData.limited = selected.data("limited");
			premiumData.title = selected.parent().find('.giftTitle').html();
			premiumData.ticket_location = selected.data("ticketlocation");
			premiumData.ticket_date = selected.data("ticketdate");
			premiumData.ticket_time = selected.data("tickettime");
			
			if(selected.data("limited") && (Backbone.settings.flags.volunteer || Backbone.settings.flags.callcenter)){
				alert("ATTENTION: The shown amount available is only updated when you refresh the page. This gift is not guaranteed until the pledge is complete.\n\nIf we have no more available at that time, a message will be shown and the pledge will not go through so that another gift can be chosen.")
			}


			triggerUpdated()		
		}
		,clearPremiumData:function(){
			premiumData.id = "";
			premiumData.sfid = "";
			premiumData.amount = "";
			premiumData.category = "";
			premiumData.limited = "";
			premiumData.title = "";
			premiumData.ticket_location="";
			premiumData.ticket_date="";
			premiumData.ticket_time="";
			
			triggerUpdated();
		}
	})
	
	
	return new (view)();
});